import { Button, Group, Text } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { IconTableExport } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';

type AgedBalanceDateRangeAndExportProps = {
  startDateInputProps: React.ComponentProps<typeof DatePickerInput>;
  endDateInputProps: React.ComponentProps<typeof DatePickerInput>;
  maxDate: Date;
  onExport: () => void;
};

export const AgedBalanceDateRangeAndExport = ({
  startDateInputProps,
  endDateInputProps,
  maxDate,
  onExport,
}: AgedBalanceDateRangeAndExportProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Group gap={6}>
        <DatePickerInput
          miw={110}
          size="xs"
          clearable
          placeholder={t(i18nKeys.FORM.START_DATE)}
          popoverProps={{ shadow: 'md' }}
          maxDate={maxDate}
          {...startDateInputProps}
        />
        <Text>-</Text>
        <DatePickerInput
          miw={110}
          size="xs"
          clearable
          placeholder={t(i18nKeys.FORM.END_DATE)}
          popoverProps={{ shadow: 'md' }}
          maxDate={maxDate}
          {...endDateInputProps}
        />
      </Group>
      <Button
        onClick={onExport}
        variant="light"
        size="xs"
        leftSection={<IconTableExport stroke="1.5" size={14} />}
      >
        {t(i18nKeys.EXPORT)}
      </Button>
    </>
  );
};
